export default (hit, isInit) => {
  return `
  <a onclick="_paq.push(['trackEvent', 'engages-passionnes', 'article', 'Lire l'article']);" href="${hit.path}" class="card card--${hit.tag && hit.tag.length > 0 ? hit.tag[0] : 'no-tag'} bg-white text-indigo-blue">
    <div class="card__picto rounded-top-right">
        <svg width="22" height="22" class="icon--white">
            <use href="#icon-article" xlink:href="#icon-article" />
        </svg>
    </div>

    <div class="card__top-article has-overlay">
        <img class="object-fit-image" src="https://res.cloudinary.com/dl8lvr6ag/image/upload/c_fill,f_auto,q_auto,w_384,h_248/${hit.picture.singleMedia.publicId}" alt="${hit.title}" />
    </div>

    <p class="title title--5 text-center card__article-cat text-white">Article</p>

    <div class="flex-grow padded-content">
        <div class="pt-6">
            ${hit.tag
              ? hit.pillarName.map((tag, i) => {
                return (
                  `<span class="tag tag--${hit.tag[i]} mb-2 ${i !== hit.tag.length - 1 ? 'mr-1' : ''}">${tag}</span>`
                )
              }).join('')
              : ''
            }

            <p class="title title--4 mb-3 mt-4">${hit.title}</p>

            ${hit.chapo
              ? `<p class="card__txt">${hit.chapo}</p>`
              : ''
            }
        </div>

        <span class="cta cta--icon mt-5">
            ${config.trads.read_article}
            <svg width="13" height="10" class="icon--indigo-blue">
                <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
            </svg>
        </span>
    </div>
  </a>
  `
}
